import { ARTICLES } from "../../constants";
import { stateType } from "../../state";
import { ApplicationPage, articleType } from "../ApplicationsPage";

export function Finance({ state }: stateType) {
  if (state.articleApplicationSelected !== ARTICLES.finance) {
    state.setArticleApplicationSelected(ARTICLES.finance);
  }
  const sections = [{ sectionName: "Testing", content: Section1 }];
  const article = {
    articleName: ARTICLES.finance,
    sections: sections,
    created: "13-June-2021",
  } as articleType;
  return <ApplicationPage state={state} article={article}></ApplicationPage>;
}

function Section1() {
  <div>Test</div>;
}
